import { StudentGroup } from '../../plugins/api'

export default {
  namespaced: true,
  state: {
    studentGroups: []
  },
  actions: {
    async fetchStudentGroups({ commit }) {
      const res = await StudentGroup.fetch({ _limit: -1 })
      commit('setStudentGroups', res)
    }
  },
  mutations: {
    setStudentGroups(state, studentGroups) {
      state.studentGroups = studentGroups
    }
  },
  getters: {}
}
